module.exports = __webpack_public_path__ + "img/login-logo.f3132e1d.png";